import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { PlotlyModule } from 'angular-plotly.js';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';

const routes: Routes = [
  { path: 'leaderboard', component: LeaderboardComponent },
];

@NgModule({
  declarations: [LeaderboardComponent],
  imports: [
    CommonModule,
    FormsModule,
    PlotlyModule,
    RouterModule.forChild(routes),
  ],
})
export class LeaderboardModule {}
